import InvoiceIcon from "@assets/images/invoices.svg";
import ShippingIcon from "@assets/images/shipping-icon.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl/lib";

import { CustomerContext } from "../../CollectionFormSubmit";
import { ShippingTypeEnum } from "../Shipping";

export interface ModalShippingProps {
  onClose?: () => void;
  visible?: boolean;
  type: ShippingTypeEnum;
  address: any[];
  handleApplyShipping: (value: string) => void;
  initialValue?: string;
}

export const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "20px 24px 10px"
    },
    mainTitle: {
      fontSize: "2rem",
      color: theme.palette.grey[900],
      fontWeight: 700
    },
    subTitle: {
      color: theme.palette.info.main,
      fontWeight: 400,
      fontSize: "1.6rem"
    },
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 480,
        width: "100%",
        borderRadius: 12
      },
      "& .MuiDialogTitle-root": {
        paddingTop: 24
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem"
      }
    },
    detailTitle: {
      fontWeight: "bold",
      marginBottom: 10,
      "& .normalText": {
        fontWeight: "normal"
      }
    },
    dialogContent: {
      maxHeight: "calc(100% - 64px)",
      overflow: "auto"
    },
    buttonAction: {
      width: "50%",
      height: 48
    }
  }),
  { name: "ModalShipping" }
);

const ModalShipping: React.FC<ModalShippingProps> = props => {
  const { visible, onClose, type, address, handleApplyShipping } = props;
  const { formik } = useContext(CustomerContext);
  const [shipping, setShipping] = useState<string>("");
  const classes = useStyles();

  useEffect(() => {
    if (type === ShippingTypeEnum.Delivery) {
      const getValue = formik.values?.shipTo;
      setShipping(getValue);
    }
    if (type === ShippingTypeEnum.TaxInvoices) {
      const getValue = formik.values?.billTo;
      setShipping(getValue);
    }
  }, [type]);
  const clearSelectVariant = () => {
    onClose();
    setShipping("");
  };

  const dataRenderModal = {
    iconHead:
      type === ShippingTypeEnum.TaxInvoices ? InvoiceIcon : ShippingIcon,
    titleHead:
      type === ShippingTypeEnum.TaxInvoices
        ? "เลือกที่อยู่สำหรับออกใบกำกับภาษี"
        : "เลือกสถานที่จัดส่งสินค้า",
    shippingAddres: address,
    label:
      type === ShippingTypeEnum.TaxInvoices
        ? "ข้อมูลที่อยู่สำหรับออกใบกำกับภาษี"
        : "ข้อมูลสถานที่จัดส่ง"
  };

  const handleSubmit = () => {
    handleApplyShipping(shipping);
    clearSelectVariant();
  };

  const getAddressValue = addresses => {
    const address1 = addresses.streetAddress1;
    const address2 = addresses.streetAddress2;
    return Object.values({
      address1,
      address2
    })
      .filter(i => Boolean(i))
      .join(", ");
  };
  return (
    <>
      <Dialog open={visible} onClose={onClose} className={classes.root}>
        <DialogTitle className={classes.dialogTitle}>
          <img src={dataRenderModal?.iconHead} alt={type.toString()} />
          <MyTypography variant="h6">{dataRenderModal?.titleHead}</MyTypography>
        </DialogTitle>
        <DialogContent dividers={false} className={classes.dialogContent}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <FormControl>
                <FormLabel id="demo-controlled-radio-buttons-group">
                  <MyTypography variant="subtitle3">
                    {dataRenderModal?.label}
                  </MyTypography>
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={shipping}
                  onChange={e => setShipping(e?.target?.value)}
                >
                  {dataRenderModal?.shippingAddres?.map(
                    (shippingAddress, index) => (
                      <FormControlLabel
                        key={index}
                        value={getAddressValue(shippingAddress)}
                        control={<Radio />}
                        label={getAddressValue(shippingAddress)}
                      />
                    )
                  )}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions disableSpacing={true}>
          <Button
            variant={"outlined"}
            color={"secondary"}
            className={classes.buttonAction}
            onClick={clearSelectVariant}
          >
            <FormattedMessage defaultMessage={"ยกเลิก"} />
          </Button>
          <Button
            variant={"contained"}
            color={"secondary"}
            className={classes.buttonAction}
            disabled={!Boolean(shipping)}
            onClick={handleSubmit}
          >
            <FormattedMessage defaultMessage={"ตกลง"} />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

ModalShipping.displayName = "ModalShipping";
export default ModalShipping;
